export default __webpack_public_path__ + "static/media/blog-02.f2f63464.jpg";